// framework/client/components/LogoComponent.js
import { ComponentBase } from "../core/ComponentBase.js";

export class LogoComponent extends ComponentBase {
    static styles = `
    .navbar-brand-logo {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: var(--bs-heading-color, var(--bs-body-color)) !important;
        font-size: var(--ab-text-lg);
        font-weight: 600;
        text-decoration: none;
        transition: color 0.2s ease;
        cursor: pointer; /* FIX: Ensure cursor is a pointer since it's a div */
    }
    .navbar-brand-logo:hover {
        color: var(--bs-primary) !important;
    }
    .navbar-brand-logo i {
        font-size: var(--ab-text-lg);
        margin-right: 0.25rem;
    }
    .logo-mobile {
        display: none;
    }
    /* Styles for mobile responsiveness */
    @media (max-width: 767.98px) {
        .navbar-brand-logo.hide-text-on-mobile .logo-text-span {
            display: none;
        }
        .logo-desktop {
            display: none;
        }
        .logo-mobile {
            display: inline-block;
        }
    }
`;

    constructor(config) {
        super(config);
        this.logoText = this.config.logoText || "App Logo";
        
        this._boundHandleContextChange = this.handleContextChange.bind(this);
        this._boundHandleLogoClick = this.handleLogoClick.bind(this); // FIX: Bind the click handler
        
        this.applyStyles();
    }

    static getDefaultConfig() {
        return {
            logoText: "App Logo",
            iconClass: null,
            hideTextOnMobile: false,
            displayMode: 'image', // 'image' or 'text'
            desktopLogoUrl: '/public/logo.png',
            desktopImageHeight: '50px',
            mobileLogoUrl: '/public/logo.png',
            mobileImageHeight: '35px'
        };
    }

    async initialize() {
        this.appClient.events.local.on("route-changed", this._boundHandleContextChange);
        this.appClient.events.local.on("USER_LOGGED_IN", this._boundHandleContextChange);
        this.appClient.events.local.on("USER_LOGGED_OUT", this._boundHandleContextChange);
        
        await super.initialize();
    }

    render() {
        // FIX: Reverted to a <div> with a direct click handler for reliability.
        if (!this.container) {
            this.container = document.createElement("div");
            this.container.className = "navbar-brand-logo";
            this.container.addEventListener('click', this._boundHandleLogoClick);
        }

        // Add/remove responsive class
        this.container.classList.toggle('hide-text-on-mobile', this.config.hideTextOnMobile);
        
        // Populate the content of the div.
        this.container.innerHTML = ''; 

        if (this.config.displayMode === 'image') {
            // Desktop Logo
            const desktopImg = document.createElement('img');
            desktopImg.src = this.config.desktopLogoUrl;
            desktopImg.alt = this.logoText;
            desktopImg.style.height = this.config.desktopImageHeight;
            desktopImg.className = 'logo-desktop';
            this.container.appendChild(desktopImg);

            // Mobile Logo
            const mobileImg = document.createElement('img');
            mobileImg.src = this.config.mobileLogoUrl;
            mobileImg.alt = this.logoText;
            mobileImg.style.height = this.config.mobileImageHeight;
            mobileImg.className = 'logo-mobile';
            this.container.appendChild(mobileImg);

        } else {
            if (this.config.iconClass) {
                const icon = document.createElement("i");
                icon.className = this.config.iconClass;
                this.container.appendChild(icon);
            }

            const logoTextSpan = document.createElement("span");
            logoTextSpan.textContent = this.logoText;
            logoTextSpan.className = "logo-text-span";
            this.container.appendChild(logoTextSpan);
        }

        return this.container;
    }

    // FIX: Restored the direct click handler method.
    handleLogoClick() {
        const homeRoute = this.appClient.layoutEngine._getHomeRouteForCurrentUser();
        this.appClient.layoutEngine.navigate(homeRoute);
    }

    // This handler is now only needed to potentially update the "home" destination
    // if the user's role or login status changes, affecting where the logo should navigate.
    handleContextChange() {
        // No re-render is needed, as the click handler dynamically determines the
        // correct route every time it's clicked.
    }

    destroy() {
        this.appClient.events.local.off("route-changed", this._boundHandleContextChange);
        this.appClient.events.local.off("USER_LOGGED_IN", this._boundHandleContextChange);
        this.appClient.events.local.off("USER_LOGGED_OUT", this._boundHandleContextChange);
        
        // FIX: Remove the specific event listener on destroy.
        if (this.container) {
            this.container.removeEventListener('click', this._boundHandleLogoClick);
        }
        
        super.destroy();
    }
}